import {
  MenuItem
} from 'element-ui'

// MenuItem
const menuItemOldRender = MenuItem.render

MenuItem.inject = {
  pagodaSideMenuInstance: {
    default: null
  }
}

// 为pagoda-layout中的menu菜单折叠状态时的tooltip加上样式类 在切换主题包的时候更改样式
MenuItem.render = function (h) {
  const vnode =  menuItemOldRender.call(this, h)

  if (this.pagodaSideMenuInstance && this.parentMenu.$options.componentName === 'ElMenu' && this.rootMenu.collapse && this.$slots.title) {
    vnode.children[0].componentOptions.propsData.popperClass = 'pagoda-sidemenu-tooltip__popper'
  }

  return vnode
}